var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'BaseDropdown',
    { dropped: _vm.dropped },
    { matchWidth: _vm.matchWidth },
    ('BaseDropdown-anchor-' + _vm.anchor),
    { persistLabel: _vm.persistLabel },
  ]},[_c('div',{ref:"BaseDropdownLabel",staticClass:"BaseDropdown_label",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleDropdown.apply(null, arguments)}}},[_vm._t("label",function(){return [_c('i',{class:[
          'BaseDropdown_icon',
          _vm.computedIcon,
        ]})]})],2),_c('div',{staticClass:"BaseDropdown_dropdown",style:(_vm.computedDropdownStyle)},[_vm._t("dropdown")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }